import React from 'react';
import { fmtUSD, fmtPct1 } from './helpers';

// PRD-024 — the header is no longer an input band. Per-Outcome Sell Config is
// the source of truth (edited in each worksheet row); the header is a DERIVED
// hero strip of the parent rollup:
//   Agency — Agreement value (Σ children) · Estimated cost · Expected margin
//   Client — Total contract price · Outcomes you're buying   (no cost/margin)
// Cost/margin never render on the Client view (FR-12, Principle #6).
// PRD-031 F3.1 — header money is whole dollars; header percentages carry one
// decimal. Grid line items keep cents.

function HeroCard({ k, v, sub, accent }) {
  return (
    <div className="card p-4">
      <div className="text-[10.5px] font-bold uppercase tracking-wide text-gray-600">{k}</div>
      <div className={`text-2xl font-bold tabular-nums font-mono mt-0.5 ${accent || 'text-gray-900'}`}>{v}</div>
      {sub && <div className="text-[11.5px] text-gray-600 mt-0.5">{sub}</div>}
    </div>
  );
}

export default function SellConfigBand({
  agreementValueCents = 0,
  estimatedCostCents = 0,
  projectedMarginCents = 0,
  projectedMarginPct = 0,
  outcomeCount = 0,
  distinctUnitCount = 0,
  showCost = true,
  isBuyer = false,
  stage = 'proposal',
}) {
  const isAgreement = stage === 'agreement';
  const valueLabel = isBuyer ? 'Total contract price' : 'Agreement value';
  const unitSub = `Σ of ${outcomeCount} outcome${outcomeCount === 1 ? '' : 's'} · ${distinctUnitCount} ${distinctUnitCount === 1 ? 'sell unit' : 'different sell units'}`;

  return (
    <div className={`grid gap-3 mb-1 ${isBuyer || !showCost ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1 sm:grid-cols-3'}`}>
      <HeroCard k={valueLabel} v={fmtUSD(agreementValueCents)} sub={unitSub} />

      {isBuyer ? (
        <HeroCard k="Outcomes you're buying" v={String(outcomeCount)} />
      ) : showCost ? (
        <>
          <HeroCard
            k={isAgreement ? 'Actual cost' : 'Estimated cost'}
            v={fmtUSD(estimatedCostCents)}
            accent="text-estimated"
          />
          <HeroCard
            k={isAgreement ? 'Realized margin' : 'Expected margin'}
            v={`${fmtUSD(projectedMarginCents)} · ${fmtPct1(projectedMarginPct)}`}
          />
        </>
      ) : null}
    </div>
  );
}
